import request from '@/utils/request';

// 获取硬件列表
export function getHardwareList(data) {
  return request({
    url: '/car/hardware',
    method: 'get',
    params: data,
  });
}
// 添加
export function addHardware(data) {
  return request({
    url: '/car/hardware',
    method: 'post',
    data,
  });
}
// 获取 详情
export function getHardwareDetail(id) {
  return request({
    url: '/car/hardware/' + id,
    method: 'get',
  });
}
// 删除
export function deleteHardware(id) {
  return request({
    url: '/car/hardware/' + id,
    method: 'delete',
  });
}
// 修改
export function updateHardware(data) {
  return request({
    url: '/car/hardware/' + data.id,
    method: 'put',
    data,
  });
}

// 不分页列表
export function getAllHardwareList(data) {
  return request({
    url: '/car/hardware/selectList',
    method: 'get',
    params: data,
  });
}
